import React, { Fragment } from 'react';
import { useController, ApplicationView as view } from '@aha-app/mvc';
import CardUiItem from './CardUiItem';
import ItemList from 'javascripts/dnd/components/ItemList';
import styles from './styles.module.css';
import type CardLayoutEditorController from '../controllers/CardLayoutEditorController';
import { type UiItem } from '../controllers/types';
import DraggableUiItem from '../dnd/DraggableUiItem';

type UiItemPreviewProps = {
  // The UI Item
  uiItem: UiItem;
};

const UiItemPreview: React.FC<UiItemPreviewProps> = ({ uiItem }) => {
  const controller = useController<CardLayoutEditorController>();

  return (
    <Fragment>
      <dt>{uiItem.title}</dt>
      <dd className={styles.fieldSet}>
        <ItemList
          items={[uiItem]}
          createDraggableItem={item =>
            new DraggableUiItem({
              controller,
              item,
            })
          }
          hideDragPreviews={false}
          listKey={`UiItemPreview-${uiItem.id}`}
          ItemComponent={CardUiItem}
        />
      </dd>
    </Fragment>
  );
};

export default view(UiItemPreview);
